var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.408,
    height: 26.459,
    viewBox: "0 0 26.408 26.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40877",
    "data-name": "Group 40877",
    transform: "translate(-308.742 42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35620",
    "data-name": "Path 35620",
    d: "M329.817-42q2.011,1.009,4.022,2.017,4.078,2.038,8.157,4.073l.282.142h-25.3c.1-.058.164-.1.228-.129l12.169-6.066c.014-.007.022-.024.033-.037Z",
    transform: "translate(-7.664)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35621",
    "data-name": "Path 35621",
    d: "M309.31,299.994c-.042-.026-.083-.054-.127-.077a.761.761,0,0,1-.384-.982,5.431,5.431,0,0,1,1.114-1.782,1.435,1.435,0,0,1,.54-.255.679.679,0,0,1,.23-.005q11.261,0,22.523-.006a1.013,1.013,0,0,1,.959.476c.335.546.657,1.1.985,1.649v.413a1.168,1.168,0,0,1-.567.568Z",
    transform: "translate(0 -315.535)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35622",
    "data-name": "Path 35622",
    d: "M335.169,71.353a7.052,7.052,0,0,1-1.285,2.328c-.1.118-.2.234-.3.351a.9.9,0,0,1-.727.32c-.713-.006-1.426,0-2.14,0q-9.757,0-19.515.005a1.139,1.139,0,0,1-.943-.423,6.864,6.864,0,0,1-1.4-2.355c-.031-.1-.055-.2-.092-.328h26.406Z",
    transform: "translate(-0.019 -105.447)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35623",
    "data-name": "Path 35623",
    d: "M353.922,138.918h4.662v9.321h-4.662Z",
    transform: "translate(-42.067 -168.452)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35624",
    "data-name": "Path 35624",
    d: "M583.834,148.379h-4.661v-9.321h4.661Z",
    transform: "translate(-251.797 -168.582)",
    fill: "#bbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35625",
    "data-name": "Path 35625",
    d: "M471.493,148.37h-4.611v-9.321h4.611Z",
    transform: "translate(-147.243 -168.574)",
    fill: "#bbb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankBank);
export default __webpack_public_path__ + "static/media/blank-bank.afc5ba3e6357a54926dbd2be3933c135.svg";
export { ForwardRef as ReactComponent };